import { AudioLines, FileX2, ImageOff } from "lucide-react";

import { cn } from "@/lib/utils";

const MEDIA = {
	image: { icon: ImageOff, label: "Imagem indisponível" },
	audio: { icon: AudioLines, label: "Áudio indisponível" },
	file: { icon: FileX2, label: "Arquivo indisponível" },
};

export function MediaUnavailable({
	kind,
	className,
}: {
	kind: keyof typeof MEDIA;
	className?: string;
}) {
	const Icon = MEDIA[kind].icon;

	return (
		<div className={cn("@container w-64 max-w-full", className)}>
			<div className="flex min-h-16 items-center gap-3 py-2 @max-[10rem]:flex-col @max-[10rem]:gap-1 @max-[10rem]:text-center">
				<span className="grid size-10 shrink-0 place-items-center rounded-lg bg-primary/5 text-primary/60 @max-[10rem]:size-8">
					<Icon className="size-5" aria-hidden="true" />
				</span>
				<p className="min-w-0 text-sm leading-snug text-muted-foreground @max-[10rem]:text-xs">
					{MEDIA[kind].label}
				</p>
			</div>
		</div>
	);
}
